var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.37479 7.45381L1.91688 4.99589C1.64063 4.71964 1.19437 4.71964 0.918125 4.99589C0.641875 5.27214 0.641875 5.71839 0.918125 5.99464L3.87896 8.95548C4.15521 9.23173 4.60146 9.23173 4.87771 8.95548L12.3719 1.46131C12.6481 1.18506 12.6481 0.738809 12.3719 0.462559C12.0956 0.186309 11.6494 0.186309 11.3731 0.462559L4.37479 7.45381Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.c12eca67dcafafbd9181dcca856da764.svg";
export { ForwardRef as ReactComponent };